import { render, staticRenderFns } from "./TableTurmas.vue?vue&type=template&id=3a01ac94&scoped=true"
import script from "./TableTurmas.vue?vue&type=script&lang=js"
export * from "./TableTurmas.vue?vue&type=script&lang=js"
import style0 from "./TableTurmas.vue?vue&type=style&index=0&id=3a01ac94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01ac94",
  null
  
)

export default component.exports